import { prettify, renderEUDate } from "../../utils/utils";
import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";

const columns = (handleOpenViewPatient) => {
  return [
    {
      size: 100,
      muiTableHeadCellFilterTextFieldProps: { placeholder: "Cerca" },
      filterFn: "contains",
      accessorFn: (row) =>
        row.patient_info === undefined ? "" : `${row.patient_info}`, // per ora
      muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
      muiTableBodyCellProps: ({ cell }) => ({
        onClick: () => {
          handleOpenViewPatient(cell.row.original.patient_id);
        },
        sx: { cursor: "pointer" },
      }),
      header: "Paziente",
    },
    {
      size: 100,
      muiTableHeadCellFilterTextFieldProps: { placeholder: "Cerca" },

      filterVariant: "select",
      accessorFn: (row) =>
        row.doctor_info === undefined ? "" : `${row.doctor_info}`,
      muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
      muiTableBodyCellProps: ({ cell }) => ({
        onClick: () => {
          alert("tbi");
        },
      }),
      id: "professionista_sanitario",
      header: "Prof. Sanitario",
    },
    {
      size: 150,
      muiTableHeadCellFilterTextFieldProps: { placeholder: "Cerca" },

      filterVariant: "select",
      accessorFn: (row) => prettify(row.service),
      muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
      header: "Telemonitoraggio",
    },
    {
      muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
      size: 100,
      accessorFn: (row) => renderEUDate(row.start_date),
      accessorKey: "start_date",
      header: "Data di Inizio",
    },
    {
      muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
      size: 100,
      accessorFn: (row) => renderEUDate(row.end_date),
      header: "Data di Fine",
    },
    {
      size: 25,
      enableColumnFilter: false, // TODO
      muiTableHeadCellFilterTextFieldProps: {
        placeholder: "Attivo/inattivo",
      },
      accessorFn: (row) => (row.is_active ? "true" : "false"),
      filterVariant: "checkbox",
      Cell: ({ cell }) =>
        cell.getValue() === "true" ? (
          <DoneIcon color="success" />
        ) : (
          <CloseIcon color="error" />
        ),
      muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
      header: "Attivo",
    },
    {
      size: 25,
      muiTableHeadCellFilterTextFieldProps: { placeholder: "Cerca" },
      accessorKey: "org_name",
      muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
      header: "Org",
      filterVariant: "select",
    },
  ];
};

export default columns;
